const fallbackFindIndex = (arr, item) => arr.indexOf(item);
function toggleItemInArray(array, item, config) {
  const findIndex = (config == null ? void 0 : config.findIndex) ?? fallbackFindIndex;
  const newArr = [...array];
  const index = findIndex(array, item);
  if (index > -1) {
    newArr.splice(index, 1);
  } else {
    newArr.push(item);
  }
  return newArr;
}

export { toggleItemInArray };
//# sourceMappingURL=deprecated.toggle-item-in-array.js.map
